import React, { useState } from "react";
import { Folder, LibraryAdd, LibraryAddCheck, Description, Send } from '@material-ui/icons';
import { AppBar, Box, Tab, Tabs } from '@material-ui/core';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
/********** COMPONENTS **********/
import TitleWithIconBar from 'component/TitleWithIcon';
import IngresarAdherentes from './IngresarAdherente';
import PaquetesOperados from "./PaquetesOperados";
import PaquetesEnviados from "./PaquetesEnviados";
import PaquetesCreados from "./PaquetesCreados";
import CrearPaquete from './CrearPaquete';
/********** REDUX **********/
import mapStateToProps from './mapStateToProps';
/********** STYLES **********/
import { useStyles } from './style';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div role="tabpanel" hidden={value !== index} id={`scrollable-force-tabpanel-${index}`} aria-labelledby={`scrollable-force-tab-${index}`} {...other} >
            {value === index && (
                <Box p={3}>
                    <div>{children}</div>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return { id: `scrollable-force-tab-${index}`, 'aria-controls': `scrollable-force-tabpanel-${index}` };
}
const SolicitudesAdhesion = (props) => {
/********** VARIABLES **********/
    const dataOPRedux = props.dataOP;
    const currentUser = props.currentUser;
    const classes = useStyles();
    const [descriptionArray] = useState([
        'Para agregar adherentes ingrese el número de la hoja y presione el botón "Buscar hoja".',
        'Para crear un paquete nuevo, primero seleccione las hojas que quiere agregar.',
        'Si el paquete se encuentra listo, presione el botón "Enviar Paquete" para iniciar el proceso de Depuración.',
        'Descargue la constancia en la columna "Documentos" y adjuntela al paquete físico para su entrega.',
        'Cuando la dependencia de Organizaciones Políticas depure la información el "Estado" del paquete se mostrará como "Paquete Operado".']);
    const [value, setValue] = useState(0);

/********** FUNCTIONS **********/
    const handleChange = (event, newValue) => { setValue(newValue); };

    /********** RENDER **********/
    return (
        <div className={classes.root}>
            <TitleWithIconBar title="Solicitudes de registro de adhesión" description={descriptionArray[value]} icon={"/menu/Constancia.png"} />
            <AppBar position="static" color="default" elevation={0}>
                <Tabs value={value} onChange={handleChange} variant="scrollable" scrollButtons="on" indicatorColor="primary"
                    textColor="primary" aria-label="scrollable force tabs example">
                    <Tab label="Ingresar Adherentes" icon={<LibraryAdd />} {...a11yProps(0)} />
                    <Tab label="Crear Paquete" icon={<Description />} {...a11yProps(1)} />
                    <Tab label="Paquetes Creados" icon={<Folder />} {...a11yProps(2)} />
                    <Tab label="Paquetes Enviados" icon={<Send />} {...a11yProps(3)} />
                    <Tab label="Paquetes Operados" icon={<LibraryAddCheck />} {...a11yProps(4)} />
                </Tabs>
            </AppBar>
            {/* Ingreso Adherentes*/}
            <TabPanel value={value} index={0}>
                <IngresarAdherentes dataOp={dataOPRedux} />
            </TabPanel>
            {/* Crear Paquete */}
            <TabPanel value={value} index={1}>
                <CrearPaquete dataOp={dataOPRedux} />
            </TabPanel>
            {/* Paquetes Creados */}
            <TabPanel value={value} index={2}>
                <PaquetesCreados dataOp={dataOPRedux} />
            </TabPanel>
            {/* Paquetes Enviados */}
            <TabPanel value={value} index={3}>
                <PaquetesEnviados dataOp={dataOPRedux} />
            </TabPanel>
            {/* Paquetes Operados */}
            <TabPanel value={value} index={4}>
                <PaquetesOperados dataOp={dataOPRedux} currentUser={currentUser}/>
            </TabPanel>
            <br /> <br /> <br /> <br />
        </div>
    );
}

export default connect(mapStateToProps)(SolicitudesAdhesion);